import React, { useCallback, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import GalleryMultiselect, {
  GallerySelectItem,
} from '../../../common/GalleryMultiselect';
import { fetchGallections } from '../../../redux/actions/gallections';

import s from './StashFolderSelect.scss';

interface Props {
  className?: string;
}

const StashFolderSelect: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const id = useId();
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState<GallerySelectItem[] | null>(null);
  const dispatch = useDispatch();

  const onChange = () => {};
  const onOpen = useCallback(() => {
    if (items === null) {
      setIsLoading(true);
      dispatch(
        fetchGallections({
          type: 'stash',
          onSuccess: response => {
            setItems(
              response.results
                .filter(result => !result.isHidden)
                .map(result => ({
                  gallery: result,
                  value: `${result.folderId}`,
                  selected: false,
                  label: result.name,
                }))
            );
            setIsLoading(false);
          },
          onError: () => {
            dispatch(addErrorNotification(t('somethingWentWrong')));
            setIsLoading(false);
          },
        })
      );
    }
  }, [items, dispatch, t]);

  return (
    <GalleryMultiselect
      className={className}
      listClassName={s['list']}
      id={id}
      label={t('originals.deviationSubmit.form.visibility.stash.label')}
      placeholder={t(
        'originals.deviationSubmit.form.visibility.stash.placeholder'
      )}
      items={items ?? []}
      isLoading={isLoading}
      onChange={onChange}
      onOpen={onOpen}
    />
  );
};
StashFolderSelect.displayName = 'StashFolderSelect';

export default StashFolderSelect;
